// src/components/common/Sidebar.js
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import {
  HomeIcon,
  CogIcon,
  UserIcon,
  QuestionMarkCircleIcon,
  ArrowRightOnRectangleIcon,
  SparklesIcon
} from '@heroicons/react/24/outline'
import Logo from "./logo";

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Repositories', href: '/repositories', icon: HomeIcon },
  { name: 'Account', href: '/account', icon: UserIcon },
  { name: 'Help / Docs', href: '/help', icon: QuestionMarkCircleIcon },
]

export default function Sidebar() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login')
  }

  return (
      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 px-6 pb-4 border-r border-slate-700/50">
        {/* Logo Section */}
        <div className="flex h-16 shrink-0 items-center mt-3">
          <div className="flex items-center gap-3"> {/* 稍微调整了 gap */}

            {/* 2. 用你的 Logo 组件替换原来的 div */}
            <Logo className="w-8 h-10" />

            <div className="text-xl font-bold bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
              EchoGuard
            </div>
          </div>
        </div>

        <nav className="flex flex-1 flex-col">
          <ul role="list" className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul role="list" className="-mx-2 space-y-2">
                {navigation.map((item) => (
                    <li key={item.name}>
                      <NavLink
                          to={item.href}
                          className={({ isActive }) =>
                              `group flex gap-x-3 rounded-xl p-3 text-sm leading-6 font-medium transition-all duration-200 ${
                                  isActive
                                      ? 'bg-gradient-to-r from-blue-600/20 to-purple-600/20 text-white border border-blue-500/30 shadow-lg shadow-blue-500/10'
                                      : 'text-slate-300 hover:text-white hover:bg-slate-800/50 hover:border hover:border-slate-600/50'
                              }`
                          }
                      >
                        <item.icon className={`h-5 w-5 shrink-0 ${
                            ({ isActive }) => isActive ? 'text-blue-400' : 'text-slate-400 group-hover:text-slate-300'
                        }`} aria-hidden="true" />
                        {item.name}
                      </NavLink>
                    </li>
                ))}
              </ul>
            </li>

            {/* User Section */}
            <li className="mt-auto">
              <div className="border-t border-slate-700/50 pt-6">
                <div className="flex items-center gap-x-3 mb-4 p-3 rounded-xl bg-slate-800/30 border border-slate-700/30">
                  <div className="relative">
                    <img
                        className="h-10 w-10 rounded-xl ring-2 ring-slate-600/50"
                        src={user?.user_metadata?.avatar_url || `https://github.com/${user?.user_metadata?.user_name}.png`}
                        alt=""
                    />
                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-slate-800"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-white truncate">
                      @{user?.user_metadata?.user_name}
                    </p>
                  </div>
                </div>

                <button
                    onClick={handleSignOut}
                    className="group flex w-full gap-x-3 rounded-xl p-3 text-sm leading-6 font-medium text-slate-300 hover:text-white hover:bg-red-500/10 hover:border hover:border-red-500/30 transition-all duration-200"
                >
                  <ArrowRightOnRectangleIcon className="h-5 w-5 shrink-0 text-slate-400 group-hover:text-red-400" aria-hidden="true" />
                  Logout
                </button>
              </div>
            </li>
          </ul>
        </nav>
      </div>
  )
}
